// extracted by mini-css-extract-plugin
export default {"footer":"AiAgentConfigDialogFooter_footer__WC95f","actionButtons":"AiAgentConfigDialogFooter_actionButtons__axEef"};